(function ($, Drupal) {

  Drupal.behaviors.notificationBar = {

    attach: function (context, settings) {

      // Notification bar is hidden by default
      // So you never see a flash of it when it should be hidden

      var $notificationBar = $('.alert.notification-bar');
      var $closeButton = $('.alert__close-button button');
      var barHidden = sessionStorage.getItem('bar');

      // Show bar if it hasn't previously been hidden
      // We can tell if it's previously been hidden
      // based on whether there's anything in sessionStorage
      once('notificationBar', '.notification-bar', context).forEach(function (element, index) {
        if (!barHidden) {
          $notificationBar.show();
        }
      });

      // Hide bar if the close button is clicked
      // this can only happen if it's not hidden
      // so we don't need to worry about whether it is or not
      $closeButton.click(function () {
        $notificationBar.slideUp();
        // Tell session storage we've hidden it
        sessionStorage.setItem('bar', 'hidden');
      });
    }

  };

})(jQuery, Drupal);
